export enum AnimationState {
    playing,
    paused,
}
